import React from "react";
import { typography } from "@streeteasy/design-system";
import { bool, string } from "prop-types";

import * as S from "./styled";

const { H6, P } = typography;

const AgentDescription = ({
  agentImageSrc,
  agentName,
  brokerage,
  className,
  isPro
}) => (
  <div className={className}>
    <S.AgentDescriptionHeader>
      <S.AgentImage isPro={isPro} src={agentImageSrc} />
      <S.AgentInfoContainer data-qa="agent-details">
        <H6 data-qa="agent-name">{agentName}</H6>
        <P data-qa="brokerage">{brokerage}</P>
      </S.AgentInfoContainer>
    </S.AgentDescriptionHeader>
    <P>
      {agentName} is a partner agent with the StreetEasy Experts advertising
      program and has experience with similar homes in the area.
    </P>
  </div>
);

AgentDescription.propTypes = {
  agentImageSrc: string,
  agentName: string.isRequired,
  brokerage: string.isRequired,
  className: string,
  isPro: bool
};

AgentDescription.defaultProps = {
  agentImageSrc: null,
  className: null,
  isPro: false
};

export default AgentDescription;
